// Code generated by Slice Machine. DO NOT EDIT.

import dynamic from "next/dynamic";

export const components = {
  carrousel: dynamic(() => import("./Carrousel")),
  contact_form: dynamic(() => import("./ContactForm")),
  hero: dynamic(() => import("./Hero")),
  liens: dynamic(() => import("./Liens")),
  logo_list: dynamic(() => import("./LogoList")),
  nav_items: dynamic(() => import("./NavItems")),
  social_media: dynamic(() => import("./SocialMedia")),
  testimonial_slider: dynamic(() => import("./TestimonialSlider")),
  text_image_section: dynamic(() => import("./TextImageSection")),
  text_marquee: dynamic(() => import("./TextMarquee")),
  text_with_sticker: dynamic(() => import("./TextWithSticker")),
  texte: dynamic(() => import("./Texte")),
};
